import { useState } from 'react'

export function useData() {
  const [searchDrawerOpen, setSearchDrawerOpen] = useState(false)
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [addLeadDrawerOpen, setAddLeadDrawerOpen] = useState(false)

  return {
    searchDrawerOpen,
    setSearchDrawerOpen,
    setFilterDrawerOpen,
    filterDrawerOpen,
    addLeadDrawerOpen,
    setAddLeadDrawerOpen,
  }
}

export type UseDataReturn = ReturnType<typeof useData>
